import script from "./legend-row.vue?vue&type=script&lang=ts&setup=true"
export * from "./legend-row.vue?vue&type=script&lang=ts&setup=true"

import "./legend-row.vue?vue&type=style&index=0&id=2d1c8e38&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d1c8e38"]])

export default __exports__